import { render, staticRenderFns } from "./OtherLinks.vue?vue&type=template&id=ca01ea9c&scoped=true&"
import script from "./OtherLinks.vue?vue&type=script&lang=js&"
export * from "./OtherLinks.vue?vue&type=script&lang=js&"
import style0 from "./OtherLinks.vue?vue&type=style&index=0&id=ca01ea9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca01ea9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VContainer,VDataTable,VSpacer,VTextField,VToolbar})
